module.exports = __webpack_public_path__ + "img/reporting_posts_date.4ad054c4.svg";